<script>
import VehicleInfoComponent from '@/components/VehicleInfoComponent'
import RightLayout from '@/router/layouts/rightLayout'
export default {
  components: { VehicleInfoComponent, RightLayout }
}
</script>

<template>
  <right-layout>
    <vehicle-info-component
    :title="'車両を登録'"
    :btnName="'登録'"
    :type="'info'"
    :func="'login'"
    ></vehicle-info-component>
  </right-layout>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/router/views/VehicleLogin.vue